export enum SettingsConfigEnum {
    CoreBusinessDetails = 0,
    ContextCompaction = 1,
    SpamProtection = 2,
    DailyCallSummaries = 3
}
